import site_routes from '@/router/routes/site'
import admin_routes from '@/router/routes/admin'
import new_admin_routes from '@/router/routes/new_admin'
import auth_admin from '@/router/routes/auth-admin'

var routes = [site_routes, admin_routes, new_admin_routes, auth_admin]

export default routes
